import { useTheme } from 'styled-components';

import { TextType, Typography } from '@libs/components';
import { AppFontKeys } from '@libs/theme';

import { useTranslation } from 'src/hooks';

import {
  ActionButtonContainer,
  ActionButtonWrapper,
  ArrowIcon,
  CustomTypography,
  IconRightComponentWrapper,
  IconWrapper,
  Img,
  RightCornerTextWrapper,
  TextsWrapper,
  TitleWrapper,
  Notice,
  BalanceWrapper,
  FlexContainer,
} from './styles';

type NavigationActionButtonProps = {
  title?: string;
  titleLabel?: JSX.Element;
  description?: string;
  descriptionBold?: string;

  topRightComponent?: JSX.Element;
  icon?: JSX.Element | string;
  disabled?: boolean;
  isLarge?: boolean;
  handleClick?: () => void;
  rightCornerText?: string;
  className?: string;
  noticeText?: string;
  balanceDetails?: string;
  shouldShowBalanceInfo?: boolean;
  descriptionType?: TextType;
  titleFont?: AppFontKeys;
  actionBadge?: JSX.Element;
};
export const NavigationActionButton: React.FC<NavigationActionButtonProps> = ({
  title,
  description,
  descriptionBold,
  icon,
  titleLabel,
  topRightComponent,
  disabled,
  isLarge = false,
  handleClick,
  rightCornerText,
  className,
  noticeText,
  balanceDetails,
  shouldShowBalanceInfo,
  descriptionType = 'caption',
  titleFont = 'primaryBold',
  actionBadge,
}) => {
  const { colors } = useTheme();

  const { t } = useTranslation();

  const balanceTitle = t('common_balance');

  const balanceInfo = balanceDetails
    ? `${balanceTitle} ${balanceDetails}`
    : null;

  return (
    <ActionButtonContainer
      onClick={handleClick}
      className={className}
      disabled={disabled}
    >
      <ActionButtonWrapper isLarge={isLarge}>
        <IconRightComponentWrapper
          disabled={disabled}
          isLarge={isLarge}
          className="right-component"
        >
          <IconWrapper>
            {typeof icon === 'string' ? <Img src={icon} /> : icon}
          </IconWrapper>

          {topRightComponent ? topRightComponent : null}
        </IconRightComponentWrapper>
        <FlexContainer>
          <TextsWrapper>
            <TitleWrapper>
              <BalanceWrapper>
                <CustomTypography
                  className="nav-action-title"
                  type="subHeadline"
                  fontFamily={titleFont}
                  disabled={disabled}
                >
                  {title}
                </CustomTypography>
                {shouldShowBalanceInfo && (
                  <Typography
                    type="bodyButton"
                    fontFamily="primaryMedium"
                    color={colors.text.secondary}
                  >
                    {balanceInfo}
                  </Typography>
                )}
              </BalanceWrapper>

              {titleLabel ? titleLabel : null}
            </TitleWrapper>

            <CustomTypography
              type={descriptionType}
              fontFamily="primaryMedium"
              disabled={disabled}
              color={colors.text.secondary}
            >
              {description}
              {descriptionBold && (
                <CustomTypography
                  type="caption"
                  fontFamily="primaryBold"
                  disabled={disabled}
                >
                  {' '}
                  {descriptionBold}
                </CustomTypography>
              )}
            </CustomTypography>
          </TextsWrapper>
          {noticeText && (
            <Notice>
              <Typography
                type="caption"
                fontFamily="primaryMedium"
                color={colors.text.critical}
              >
                {noticeText}
              </Typography>
            </Notice>
          )}
        </FlexContainer>
      </ActionButtonWrapper>
      {rightCornerText && (
        <RightCornerTextWrapper>
          <Typography
            color={colors.text.interactive}
            type="caption"
            fontFamily="primaryMedium"
          >
            {rightCornerText}
          </Typography>
        </RightCornerTextWrapper>
      )}

      {actionBadge ? actionBadge : null}
      <ArrowIcon isLarge={isLarge} disabled={disabled} className="arrow-icon" />
    </ActionButtonContainer>
  );
};
